/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ZerogSearchHandlerInfo = {
    ID: ZerogSearchHandlerInfo.ID;
    SRLIST: Record<string, any>;
};

export namespace ZerogSearchHandlerInfo {

    export enum ID {
        BLOCK = 'BLOCK',
        TRANSACTION = 'TRANSACTION',
        ADDRESS = 'ADDRESS',
        ADDRESS_LABEL = 'ADDRESS_LABEL',
        VALIDATOR = 'VALIDATOR',
        TOKEN = 'TOKEN',
        STORAGE_SUBMISSION = 'STORAGE_SUBMISSION',
    }


}

